import { APICore } from './apiCore';

const api = new APICore();
export function getProfile() {
    const baseUrl = '/user/profile/';
    return api.get(`${baseUrl}`, undefined);
}
